export default {
  id: 17,
  pride: 17408,
  slug: "omnivista-magic-academy",
  category: "ai",
  status: "halted",
  titleKey: {
    zh: "万象魔法学院（OMA)",
    en: "Omnivista Magic Academy（OMA)"
  },
  image: require('@/assets/images/magic_academy.webp'),
  descriptionKey: {
    zh: "AI原生开放世界 MUD，魔法校园冒险与 LLM 动态叙事。项目目前处于停工状态。",
    en: "AI-native open-world MUD with magical campus adventure and LLM dynamic narrative. Currently on hold."
  },
  date: { year: 2025, month: 1 },
  genres: ["MUD", "开放世界", "LLM", "角色扮演"],
  themes: ["魔法校园", "冒险", "人生模拟"],
  engine: "Node.js",
  platform: ["Web"],
  scale: {
    zh: "停工",
    en: "On Hold"
  },
  developerNotesKey: {
    zh: "项目目前处于停工状态。理论基础见《AI大世界游戏的5种可能范式》；本项按范式Ⅱ（AI MUD）推进。曾用 MUD 框架 Evennia 尝试重制，小红书上有零星关注度，暂未继续推进。",
    en: "The project is currently on hold. Theoretical basis: Five Paradigms for AI Open-World Games; this project follows Paradigm II (AI MUD). A remake was attempted with the MUD framework Evennia. It received sporadic attention on Xiaohongshu, but development has not resumed."
  },
  tags: ["LLM", "AI大世界范式Ⅱ"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "web", url: "/project/ai-world-game-paradigms", textKey: { zh: "理论基础：五种范式", en: "Theoretical Basis: Five Paradigms" } },
    { type: "xiaohongshu", url: "http://xhslink.com/a/eKWmczIAd6e5", textKey: { zh: "小红书主页", en: "Xiaohongshu Page" } },
    { type: "wechat", url: "https://mp.weixin.qq.com/s/71Ss_3ZKkt4ILZfh3J8IVQ", textKey: { zh: "开发日志", en: "Dev Log" } }
  ]
};
